<template>
  <div>
    <b-form-checkbox
      id="select-all-general-permissions"
      v-model="allSelected"
      name="select-all-general-permissions"
      class="text-capitalize mt-2"
      switch
    >
      {{ $t('hanwha_dvr.groups_permissions.select_all') }}
    </b-form-checkbox>
    <b-list-group>
      <b-list-group-item>
        <div class="row">
          <div class="col-4">
            <b-form-checkbox
              id="record-start-access"
              v-model="itemData.RecordStartAccess"
              name="record-start-access"
              class="mt-1 text-capitalize"
              switch
            >
              {{ $t('hanwha_dvr.groups_permissions.general.record') }}
            </b-form-checkbox>
          </div>
          <div class="col-4">
            <b-form-checkbox
              id="record-stop-access"
              v-model="itemData.RecordStopAccess"
              name="record-stop-access"
              class="mt-1 text-capitalize"
              switch
            >
              {{ $t('hanwha_dvr.groups_permissions.general.stop_recording') }}
            </b-form-checkbox>
          </div>
          <div class="col-4">
            <b-form-checkbox
              id="ptz-access"
              v-model="itemData.PTZAccess"
              name="ptz-access"
              class="mt-1 text-capitalize"
              switch
            >
              {{ $t('hanwha_dvr.groups_permissions.general.ptz_control') }}
            </b-form-checkbox>
          </div>
          <div class="col-4">
            <b-form-checkbox
              id="alarm-output-access"
              v-model="itemData.AlarmOutputAccess"
              name="alarm-output-access"
              class="mt-1 text-capitalize"
              switch
            >
              {{ $t('hanwha_dvr.groups_permissions.general.output_control') }}
            </b-form-checkbox>
          </div>
          <div class="col-4">
            <b-form-checkbox
              id="shutdown-access"
              v-model="itemData.ShutdownAccess"
              name="shutdown-access"
              class="mt-1 text-capitalize"
              switch
            >
              {{ $t('hanwha_dvr.groups_permissions.general.shutdown') }}
            </b-form-checkbox>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import useSelectAllSwitch from "./useSelectAllSwitch";

const BOOLEAN_KEYS = ["RecordStartAccess", "RecordStopAccess", "PTZAccess", "AlarmOutputAccess", "ShutdownAccess"];

export default {
  props: {
    itemData: {
      type: Object
    }
  },
  setup (props) {
    //COMPOSABLES
    const { allSelected } = useSelectAllSwitch({
      isAllSelected: () => BOOLEAN_KEYS.every(key => props.itemData[key] === true),
      selectAll: () => BOOLEAN_KEYS.forEach(key => { props.itemData[key] = true; }),
      deselectAll: () => BOOLEAN_KEYS.forEach(key => { props.itemData[key] = false; }),
      watchSource: () => BOOLEAN_KEYS.map(key => props.itemData[key])
    });

    return { allSelected }
  }
}
</script>
